import React, { memo } from 'react'
import { useDispatch } from 'react-redux'
import { NlpModel } from '@feedyou/schema'
import { FormValidation } from '@rjsf/utils'

import { save } from './actions/save'
import { useSchema } from './hooks/useSchema'
import { useSettingsPopupState } from '../hooks'
import { useBotFlow } from '../../../store/flow'
import { SettingsPopup } from '../SettingsPopup'
import { ModalDescriptorForType } from '../../../store/modals'
import { modalsActions } from '../../../store/modals/modalsSlice'
import { useOpenModalOpenSection } from '../../../store/modals/hooks/useOpenModalOpenSection'
import { BotHeaderTabType } from '../../../features/botHeaderTabs/types'
import { selectTab } from '../../../store/app'
import { useUiSchema } from '../sharedSchemaFragments/nlpSettings/hooks/useUiSchema'

type Props = { modalDescriptor: ModalDescriptorForType<'add_nlp_model_settings'> }

export const AddNlpModelSettingsPopup: React.FC<Props> = memo(() => {
  const flow = useBotFlow()
  const schema = useSchema()
  const dispatch = useDispatch()
  const openSection = useOpenModalOpenSection() ?? 'form'
  const settingsPopupState = useSettingsPopupState(() => ({}))

  const existingNlpModels = flow?.nlp?.models || []
  const close = () => dispatch(modalsActions.closeModal())
  const nlpModel = settingsPopupState.formData as NlpModel
  const uiSchema = useUiSchema(nlpModel?.provider?.type, nlpModel?.provider?.showSources)

  return (
    <SettingsPopup
      className="no-error-panel"
      close={close}
      schema={schema!}
      uiSchema={uiSchema.items}
      openSection={openSection}
      formData={settingsPopupState.formData}
      customTabNames={{ form: 'Model Settings' }}
      onChange={settingsPopupState.onFormDataChange}
      initialFormData={settingsPopupState.initialFormData}
      save={async formData => {
        await dispatch(save(formData))
        close()
        dispatch(selectTab({ id: formData.id, type: BotHeaderTabType.NlpModel }))
      }}
      validateSchema={(formData: any, errors: FormValidation<any>) => {
        const newModel = formData as NlpModel
        if (existingNlpModels.some(model => model.id === newModel.id)) {
          errors.addError('NLP ID already exists.')
        }

        return errors
      }}
    />
  )
})
